<template>
  <div class="dynamic l_flex_row" @click="navToDetail">
    <div class="cover">
      <el-image class="cover-img" :src="obj.banner">
        <div slot="error" style="height:100%;width:100%; display: flex;align-items: center;justify-content: center;" class="imageslot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <!-- <img :src="obj.banner" class="cover-img" alt="" /> -->
    </div>
    <div class="content l_flex_column_between">
      <p class="title">{{ obj.title }}</p>
      <div class="icons l_flex_row">
        <div class="icon-item">
          <i class="el-icon-view"></i>
          <span class="nub">{{ obj.views }}</span>
        </div>
        <div class="icon-item">
          <i class="el-icon-time"></i>
          <span class="nub">{{ obj.created_at }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navToDetail() {
      // console.log(this.obj);
      // return
      this.$router.push({
        path: "/dynamicdetail",
        query: {
          id: this.obj.id,
        },
      });
      // this.$router.push('/dynamicdetail')
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.dynamic {
  padding: 30px 0;
  height: 100%;
  font-size: 15px;
  cursor: pointer;
  .cover {
    width: 400px;
    height: 200px;
    background-color: #815a4e;
    .cover-img {
      width: 400px;
      height: 200px;
      font-size: 44px;
    }
    .imageslot {
      width: 100%;
      height: 100%;
      font-size: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .content {
    margin-left: 54px;
    height: 200px;
    align-items: flex-start;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .icons {
      color: #999999;
      .icon-item {
        margin-right: 20px;
        .nub {
          font-size: 15px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
